module.exports = __webpack_public_path__ + "bfeb394830b28aa3446e783f888ed8e1.svg";